import React, { useEffect, useState } from 'react';
import { formatUnitCalData } from '../../utilities/courseFormat';
import { getCourses } from '../../services/courseService';
import UnitOfferCalendar from './UnitOfferCalendar';
import { getCalendarAdmin } from '../../services/unitOfferService';

const DEFAULT_PAGE_SIZE = 0;
const DEFAULT_PAGE_NO = 0;

const UnitOfferCalendarView = () => {
  const className = 'c-UnitOfferCalendarView';

  const [calData, setCalData] = useState({});
  const [courses, setCourses] = useState([]);

  const fetchCalendarData = (month, year) => {
    getCalendarAdmin(DEFAULT_PAGE_NO, DEFAULT_PAGE_SIZE, {
      month: month,
      year: year,
      collection: 'unitOffer',
      timezoneId: Intl.DateTimeFormat().resolvedOptions().timeZone,
    })
      .then((res) => {
        const formattedCalData = formatUnitCalData(res.data);
        setCalData(formattedCalData);
      })
      .catch();
  };

  const handleCalChange = (moment_dt) => {
    const [month, year] = [moment_dt.month(), moment_dt.year()];
    fetchCalendarData(month + 1, year);
  };

  const fetchCourses = () => {
    getCourses()
      .then((response) => {
        const courseList = response.data.paginatedList;
        const data = courseList.map((course) => ({
          value: course.code,
          label: course.description,
        }));
        setCourses(data);
      })
      .catch((error) => {
        console.log('Error getting courses from the admin backend:', error);
      });
  };

  useEffect(() => {
    fetchCourses();
    const today = new Date();
    const [month, year] = [today.getMonth(), today.getFullYear()];
    fetchCalendarData(month + 1, year);
  }, []);

  return (
    <div className={className}>
      <UnitOfferCalendar
        title="Unit Offers"
        calData={calData}
        onCalChange={handleCalChange}
        courses={courses}
      />
    </div>
  );
};

export default UnitOfferCalendarView;
